export const GET_AVAILABLE_APPOINTMENT = 'GET_AVAILABLE_APPOINTMENT';
export const GET_MY_APPOINTMENTS = 'GET_MY_APPOINTMENTS';
export const GET_APPOINTMENT_DETAILS = 'GET_APPOINTMENT_DETAILS';
export const RESPONSE_STATUS = 'RESPONSE_STATUS';
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE';
